/* istanbul ignore file */
/* eslint-disable */

import * as React from "react";
import { TreeView } from "components/TreeView";
import { ComponentBase, applyMixins } from "@syncfusion/ej2-react-base";
import "./treeview.component.scss";

const __extends = (this && this.__extends) || (function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf
            || ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; })
            || function (d, b) { for (const p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}());
/**
 * `TreeViewComponent` represents the react TreeView Component.
 * ```ts
 * <TreeViewComponent allowDragAndDrop={true}></TreeViewComponent>
 * ```
 */
const TreeViewComponent = /** @class */ (function (_super) {
  __extends(TreeViewComponent, _super);
  function TreeViewComponent(props) {
    const _this = _super.call(this, props) || this;
    _this.initRenderCalled = false;
    _this.checkInjectedModules = true;
    _this.immediateRender = false;
    _this.portals = [];
    return _this;
  }
  TreeViewComponent.prototype.render = function () {
    if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
      _super.prototype.render.call(this);
      this.initRenderCalled = true;
    } else {
      return React.createElement("div", this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
    }
  };
  return TreeViewComponent;
}(TreeView));
export { TreeViewComponent };
applyMixins(TreeViewComponent, [ComponentBase, React.Component]);
